import React from "react";
import styles from "./ImageValidationInfo.module.css";

interface ImageValidationInfoProps {
    warnings: string[];
    className?: string;
}

/** Soft warnings only — no uploaded dimensions line. */
const ImageValidationInfo: React.FC<ImageValidationInfoProps> = ({ warnings, className = "" }) => {
    if (warnings.length === 0) {
        return null;
    }

    return (
        <div className={`${styles.container} ${className}`}>
            <div className={styles.warningContainer}>
                {warnings.map((warning, index) => (
                    <p key={index} className={styles.warningText}>
                        ⚠️ {warning}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default ImageValidationInfo;
